import Homepage from './Pages/Homepage';
import Header from './Page Sections/Header/Header';


function App() {
  return (
    <div className="App-container">
      <Header/>
      <Homepage/>
    </div>
  );
}

export default App;
